import api from '@/services/api'
import { adapterModelRoutesForSelect } from '@/services/adapter/routes'

const moduleRoutes = {
  state: {
    routes: [],
    routes_type: []
  },
  mutations: {
    ROUTES: (state, data) => {
      state.routes = data.map(item => Object.freeze(item))
    },
    ROUTES_TYPE: (state, data) => {
      state.routes_type = data.map(item => Object.freeze(item))
    }
  },
  actions: {
    ROUTES_REQUEST: ({ commit }) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get(`routes/`)
        .then(response => {
          if (response.data) {
            commit('ROUTES', response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
      })
    },
    ROUTES_TYPE_REQUEST: ({ commit }) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get(`route-types/`)
        .then(response => {
          if (response.data) {
            commit('ROUTES_TYPE', response.data)
          }
          resolve(response)
        })
        .catch(error => reject(error))
      })
    }
  },
  getters: {
    ROUTE_BY_ID: state => id => state.routes.find(i => i.id == id),
    ROUTES: state => state.routes,
    ROUTES_SELECT: state => adapterModelRoutesForSelect(state.routes),
    ROUTES_TYPE: state => state.routes_type
  }
}
export default moduleRoutes